
import students from './students.json'


export const studentsApi = () => {
  return students;
}

export const getStudent = (key, value) => {
  let res = studentsApi().find(p => p[key] === value)
  return res;
}

export const getStudents = (key, value) => {
  let res = studentsApi().filter(p => p[key] === value)
  return res;
}

export const getStudentByGradeAndName = (grade, name) => {
  let res = studentsApi().find(p => p.cls.toString() === grade.toString() && p.name_en === name)
  return res;
}

export const getStudentByNid = (nid) => {
  let res = studentsApi().find(p => p.nid === nid)
  return res;
}

export const getStudentByCls = (cls) => {
  let res = studentsApi().filter(p => p.cls === cls)
  return res;
}

export const getGrades = () => {
  let res = studentsApi().map(s=>{return s.cls})
  let resp = [...new Set(res)]
  return resp;
}